export const APIBASE = `${process.env.APIBASE}/collection-engine`;
export const FILEBASE = `${APIBASE}/files`;
export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY;
export const ENV = process.env.ENV;
export const IS_PROD = ENV === 'production';
export const CASEWORKER_URL = process.env.CASEWORKER_URL;
export const DEFAULT_DEBTOR_WEB = process.env.DEFAULT_DEBTOR_WEB;
export const DEFAULT_CREDITOR_WEB = process.env.DEFAULT_CREDITOR_WEB;
//# sourceMappingURL=config.js.map